import React from 'react';
import { Tag } from 'antd';

const statusTypes = {
        'default': 'default',
    //DocumentStatus
        'current': 'success',
        'current - draft': 'note',
        'retired': 'caution',
        'reserved': 'note',
        'marked for change': 'error',
    //RevisionStatus
        'superseded': 'warning',
        'overridden': 'note',
    //JobStatus
        'to be completed': 'note',
        'quote issued': 'success',
        'quote required': 'warning',
        'for approval': 'warning',
        'uploaded for review': 'success',
        'approved': 'success',
        'completed': 'completed',
        //'approval rejected': 'warning',
        //'approval note': 'success',
        //'revision note': 'note',
        //'authorisation rejected': 'error',
        //'authorised': 'success',
    //Check/ApprovalStatus
        'awaiting check': 'warning',
        'awaiting approval': 'warning',
        'awaiting check - current': 'warning',
        'awaiting approval - current': 'warning',
        'awaiting approval - superseded': 'warning',
        'rejected': 'error',
        'check rejected': 'error',
        'approval rejected': 'error',
        'rejected - current': 'error',
        'overriding superseded': 'error',
        'overriding current': 'error',
        'overriding current - draft': 'error',
        'existing - current': 'success',
        'existing - superseded': 'success',
};

const StatusTag = ({ type, icon }) => {
    const statusClass = statusTypes[type?.toLowerCase()] || statusTypes['default'];
    return (
        <Tag className={`chip ${statusClass}`}>
            {type}
            {icon}
        </Tag>
    );
}

export default StatusTag;
